import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Subscription } from 'rxjs'; 
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { stockistmaster } from '../../model';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-stockist-master',
    template: require('./stockistmaster.component.html'),
    styles: [require('./stockistmaster.component.css')],
    viewProviders: [ApiService]
})
export class StockistMasterComponent implements OnInit {
    static parameters = [ApiService, HttpClient, ToastrService]
    hqMasterData: any = [];
    stockistMasters: any = [];

    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    ManagerList: any;
    empData: any = [];
    toEmpData: any = [];
    token:any;
    StockistMaster: stockistmaster = new stockistmaster();
    constructor(private apiService: ApiService,private http: HttpClient,private toast: ToastrService) {
        this.apiService = apiService;
        this.columnDefs = [
            { headerName: 'Stockist Code', field: 'ChemistCode' },
            { headerName: 'Stockist Name', field: 'Chemist_Legal_Name' },
            { headerName: 'Employee Name', field: 'Client_Name' },
          
          { headerName: 'Category', field: 'Category' },
          { headerName: 'Mobile No.', field: 'MobileNo' },
          
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }
    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.StockistMaster.EmployeeCode = '0';
        this.StockistMaster.ManagerID = '0';
        this.getHqMaster();
        // this.getStockistMaster();
        this.getManagerDetails();
        this.getEmployee();
        $('#filter-option').trigger('click');

    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.sizeColumnsToFit();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'StockistMaster' });
    }

    getHqMaster() {
        this.apiService.getHQMasters().subscribe((res: any) => {
            this.hqMasterData = res.data;
        })

    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
            res.data.filter(data => {
                if (data.EmpActive == '1') {
                    this.toEmpData.push(data);
                }
              })
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }


    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    getStockistMaster() {
      
        //  console.log('token', token);
        if (this.f_chkString(this.StockistMaster.EmployeeCode) == '0' && this.f_chkString(this.StockistMaster.ManagerID) == '0') {
            this.toast.warning('Employee or Manager  is Required');
            return false;
        }
        var data = {
             Id: this.token.id,EmpCode: this.StockistMaster.EmployeeCode,
             ManagerID: this.StockistMaster.ManagerID
        };
           console.log(data);
           $("#StockistMaster").trigger('click');
        this.busy = this.apiService.getStockistMaster_web(data).subscribe((res: any) => {
            console.log('getStockistMaster data ', res);
            this.stockistMasters = res.data;
            // if (this.stockistMasters.length > 0) {
            //     let column = Object.keys(this.stockistMasters[0]);
            //     console.log('columns', column);
            //     // gridOptions.api.setColumnDefs(column);
            //     let dynamicColumnDef: any = [];
            //     column.forEach(data => {
            //         let demo: any = {
            //             headerName: data.toString(),
            //             field: data.toString()
            //         };
            //         dynamicColumnDef.push(demo);

            //     });
            //     this.columnDefs = dynamicColumnDef;
            // }
            // var self = this;
            setTimeout(function(self){
                self.api.sizeColumnsToFit();
            }, 200, this);
            
        })
    }

}